import React from 'react';
import { ReactComponent as ActiveIcon } from "assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveIcon } from "assets/img/svg/InactiveControl.svg";
import styles from "./styles.module.scss";

const SelectStatus = ({
    bankStatus,
    formHandler,
    disabled
}) => {
    return (
        <div>

            <div className={`${styles['label']}`}>Status*</div>

            <div className={styles['field-wrapper']}>

                <span>{bankStatus === "ACTIVE" ? "Active" : "Inactive"}</span>
                
                <span>
                    {
                        bankStatus === "ACTIVE"
                            ? <ActiveIcon onClick={() => !disabled && formHandler("bankStatus", "INACTIVE")} />
                            : <InactiveIcon onClick={() => !disabled && formHandler("bankStatus", "ACTIVE")} />
                    }
                </span>
            </div>
        </div>
    );
}

export default SelectStatus;